import { render } from "./BadgesDetails.vue?vue&type=template&id=2e913ce2"
import script from "./BadgesDetails.vue?vue&type=script&lang=js"
export * from "./BadgesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__